import { ToEntity } from 'core/common/mappers';
import {
  PaymentFormData,
  PaymentFormMerchantData,
  PaymentFormPaypalData,
  PaymentType,
} from '../entities';
import { PaymentFormDataDto } from '../services/dto';

export class PaymentFormDataDtoMapper implements ToEntity<PaymentFormData, PaymentFormDataDto> {
  toEntity(dto: PaymentFormDataDto): PaymentFormData {
    return {
      formMerchantData: this.mapMerchantDataDtoToEntity(dto),
      paypalPaymentData: this.mapPaypalDataDtoToEntity(dto),
    };
  }

  private mapMerchantDataDtoToEntity(dto: PaymentFormDataDto): PaymentFormMerchantData {
    const payment = dto.payments.find((p) => p.payment_method === PaymentType.CARD);

    if (!payment) {
      return {
        paymentForm: {
          merchant: '',
          paymentIntent: '',
          signature: '',
        },
        paymentId: '',
      };
    }

    return {
      paymentForm: {
        merchant: payment.payment_form.merchant,
        paymentIntent: payment.payment_form.paymentIntent,
        signature: payment.payment_form.signature,
      },
      paymentId: payment.payment_id,
    };
  }

  private mapPaypalDataDtoToEntity(dto: PaymentFormDataDto): PaymentFormPaypalData {
    const payment = dto.payments.find((p) => p.payment_method === PaymentType.PAYPAL);

    if (!payment) {
      return {
        paypalScriptUrl: '',
        paymentId: '',
      };
    }

    return {
      paypalScriptUrl: payment.payment_form.scriptUrl,
      paymentId: payment.payment_id,
    };
  }
}
